import s from "./CTA.module.scss";

const CTA = ({
    variant = "violet",
    place,
    text,
    href,
}) => {

    let classNames = s.CTA;
    if (variant === "violet") classNames += ` ${s.CTA__violet}`;
    if (variant === "orange") classNames += ` ${s.CTA__orange}`;
    if (place === "form") classNames += ` ${s.CTA__form}`;
    if (place === "headerForm") classNames += ` ${s.CTA__form__header}`;
    if (place === "sectionDefisc") classNames += ` ${s.CTA__defisc}`;


    return (
        <a 
            href={href} 
            className={classNames} 
            target="_blank"
        >
            {text}
            <span className={s.hoverEffect}></span>
        </a>
    );
};

export default CTA;